import type { InstallSourceReport, InstallSourceRow } from '@/types/installSource';

export const INSTALL_SOURCE_NOTE =
  'Sources come from builds that report AppsFlyer. Paid revenue and payers are since install, so older cohorts have had longer to pay.';

export interface InstallSourceTableRow extends InstallSourceRow {
  children?: InstallSourceTableRow[];
}

/** Groups as table rows; a network's campaigns become its expandable children. */
export function toTableRows(report: InstallSourceReport): InstallSourceTableRow[] {
  return report.groups.map(({ campaigns, kind: _kind, ...group }) =>
    campaigns.length > 0 ? { ...group, children: campaigns } : group
  );
}
